/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramAuthControllerRefreshTokenMutationRequest,
  TelegramAuthControllerRefreshTokenMutationResponse,
  TelegramAuthControllerRefreshToken401,
  TelegramAuthControllerRefreshToken403,
} from '../../types/TelegramAuthControllerRefreshToken.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramAuthRefreshToken } from '../../methods/telegramAuthRefreshToken.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramAuthRefreshTokenMutationKey = () => [{ url: '/api/telegram/auth/refresh' }] as const;

export type TelegramAuthRefreshTokenMutationKey = ReturnType<typeof telegramAuthRefreshTokenMutationKey>;

/**
 * {@link /api/telegram/auth/refresh}
 */
export function useTelegramAuthRefreshToken<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramAuthControllerRefreshTokenMutationResponse,
      ResponseErrorConfig<TelegramAuthControllerRefreshToken401 | TelegramAuthControllerRefreshToken403>,
      { data: TelegramAuthControllerRefreshTokenMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramAuthControllerRefreshTokenMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramAuthRefreshTokenMutationKey();

  return useMutation<
    TelegramAuthControllerRefreshTokenMutationResponse,
    ResponseErrorConfig<TelegramAuthControllerRefreshToken401 | TelegramAuthControllerRefreshToken403>,
    { data: TelegramAuthControllerRefreshTokenMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramAuthRefreshToken(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
